import { Promises } from "@dooboostore/core";
var ElementUtils;
((ElementUtils2) => {
  function removeAllChildren(el, els) {
    if (!els) {
      el.replaceChildren();
    } else if (Array.isArray(els)) {
      el.replaceChildren(...els);
    } else {
      el.replaceChildren(els);
    }
  }
  ElementUtils2.removeAllChildren = removeAllChildren;
  function loadImage(src, callback) {
    let targetCallback;
    let promise = void 0;
    if (callback) {
      targetCallback = callback.onload;
    } else {
      const r = Promises.withResolvers();
      promise = r.promise;
      targetCallback = r.resolve;
    }
    const img = new Image();
    img.onload = () => {
      targetCallback(img);
    };
    if (callback && callback.onerror) {
      img.onerror = callback.onerror;
    }
    img.src = src;
    return promise;
  }
  ElementUtils2.loadImage = loadImage;
  function loadAudio(src, callback) {
    let targetCallback;
    let error;
    let promise = void 0;
    if (callback) {
      targetCallback = callback.onload;
      error = callback.onerror;
    } else {
      const r = Promises.withResolvers();
      promise = r.promise;
      error = r.reject;
      targetCallback = r.resolve;
    }
    const audio = new Audio("path/to/audio1.mp3");
    audio.addEventListener("canplay", () => {
      targetCallback?.(audio);
    });
    audio.addEventListener("error", (e) => {
      callback?.onerror(e);
    });
    audio.load();
    return promise;
  }
  ElementUtils2.loadAudio = loadAudio;
  ElementUtils2.toInnerHTML = (documentFragment, config) => {
    const tempDiv = config.document.createElement("div");
    tempDiv.appendChild(documentFragment.cloneNode(true));
    return tempDiv.innerHTML;
  };
  ElementUtils2.htmlToFragment = (html, config = { document }) => {
    const tempDiv = config.document.createElement("div");
    tempDiv.innerHTML = html;
    const fragment = config.document.createDocumentFragment();
    while (tempDiv.firstChild) {
      fragment.appendChild(tempDiv.firstChild);
    }
    return fragment;
  };
  ElementUtils2.replaceWith = (targetElement, replaceElement) => {
    targetElement.replaceWith(replaceElement);
  };
  ElementUtils2.nodeList = (documentFragment) => {
    return Array.from(documentFragment.childNodes);
  };
  ElementUtils2.cloneNodeList = (documentFragment) => {
    return Array.from(documentFragment.childNodes).map((node) => node.cloneNode(true));
  };
  ElementUtils2.querySelector = (e, selector) => {
    const elements = ElementUtils2.querySelectorAll(e, selector);
    if (elements.length > 0) {
      return elements[0];
    } else {
      return null;
    }
  };
  ElementUtils2.querySelectorAll = (e, selector) => {
    if (e instanceof Element) {
      return Array.from(e.querySelectorAll(selector));
    } else {
      const startNode = e.start;
      const endNode = e.end;
      if (startNode && endNode && startNode.parentNode === endNode.parentNode) {
        const elements = [];
        let currentNode = startNode.nextSibling;
        while (currentNode && currentNode !== endNode) {
          if (currentNode.nodeType === Node.ELEMENT_NODE) {
            const currentElement = currentNode;
            if (currentElement.matches(selector)) {
              elements.push(currentElement);
            }
            elements.push(...Array.from(currentElement.querySelectorAll(selector)));
          }
          currentNode = currentNode.nextSibling;
        }
        return elements;
      }
    }
    return [];
  };
  ElementUtils2.selectorElements = (selector, element = document) => {
    return Array.prototype.slice.call(element.querySelectorAll(selector));
  };
  ElementUtils2.selectorNodes = (selector, element = document) => {
    return element.querySelectorAll(selector);
  };
  ElementUtils2.removeAttribute = (result, attrs) => {
    attrs.forEach((it) => {
      result.removeAttribute(it);
    });
  };
  ElementUtils2.setAttribute = (result, attrs) => {
    attrs.forEach((it) => {
      result.setAttribute(it, "");
    });
  };
  ElementUtils2.setAttributeAttr = (result, attrs) => {
    attrs.forEach((it) => {
      result.setAttribute(it.name, it.value);
    });
  };
  ElementUtils2.getAttributeToObject = (input) => {
    const attribute = {};
    input.getAttributeNames().forEach((ait) => {
      attribute[ait] = input.getAttribute(ait);
    });
    return attribute;
  };
  ElementUtils2.getStyleToObject = (input) => {
    const style = {};
    for (let i = 0; i < input.style.length; i++) {
      const key = input.style[i];
      style[key] = input.style[key];
    }
    return style;
  };
})(ElementUtils || (ElementUtils = {}));
export {
  ElementUtils
};
//# sourceMappingURL=ElementUtils.js.map
